import client from './client'

export const login = body => client.post('/admin/login', body)
export const dashboard = () => client.get('/admin/dashboard')
export const listClasses = () => client.get('/admin/classes')
export const createClass = body => client.post('/admin/classes', body)
export const updateClass = (id, body) => client.put('/admin/classes/' + id, body)
export const cancelClass = id => client.delete('/admin/classes/' + id)
export const roster = id => client.get('/admin/classes/' + id + '/bookings')
export const bookForMember = (classId, memberId) => client.post('/admin/classes/' + classId + '/bookings', { member_id: memberId })
export const checkin = id => client.post('/admin/bookings/' + id + '/checkin')
export const undoCheckin = id => client.post('/admin/bookings/' + id + '/undo')
export const cancelBooking = id => client.post('/admin/bookings/' + id + '/cancel')
export const listMembers = (q, deleted = false) => client.get('/admin/members', { params: { q, deleted: deleted ? '1' : '0' } })
export const deleteMember = id => client.delete('/admin/members/' + id)
export const restoreMember = id => client.post('/admin/members/' + id + '/restore')
export const createMember = body => client.post('/admin/members', body)
export const recharge = (id, amount) => client.post('/admin/members/' + id + '/credits', { amount })
export const updateMemberLevel = (id, level) => client.post('/admin/members/' + id + '/level', { level })
export const listLedger = (q, classId = '') => client.get('/admin/ledger', { params: { q, class_id: classId } })
